import React, { ButtonHTMLAttributes } from 'react'

export type Props = {
  children: React.ReactNode
} & ButtonHTMLAttributes<HTMLButtonElement>

export const IconButton = ({ children, ...others }: Props) => (
  <button
    type='button'
    className='appearance-none outline-none border-none cursor-pointer'
    {...others}
  >
    {children}
  </button>
)
